import './myReviews.css';

import { useEffect, useState } from 'react';

import EmptyPage from '../../components/empty-page/emptyPage';
import ReactLoading from 'react-loading';
import TitleBar from '../../components/titleBar/titleBar';
import TripStrap from '../../components/tripStrap/TripStrap';
import myReviewData, { myReviewCount } from './myReviewFun/myReviewData';
import Pagination from '../../components/pagination/Pagination';

export default function MyReviews() {
    const [reviewData, setReviewData] = useState([]);
    const [refetch, setRefetch] = useState(false);
    const [typeSel, setTypeSel] = useState('trip');
    const [loading, setLoading] = useState(false);
    const [pageNumber, setPageNumber] = useState(1);
    const [offSet, setOffSet] = useState(0);
    const [totalData, setTotalData] = useState(0);
    const limit = 10;

    useEffect(() => {
        setTypeSel((prev) => prev);
    }, []);

    useEffect(() => {
        myReviewCount(typeSel, setTotalData);
    }, [typeSel]);

    useEffect(() => {
        const fetchReviewData = async () => {
            try {
                await myReviewData(typeSel, setReviewData, setLoading);
            } catch (err) {
                console.log('Failed to fetch search results');
            }
        };

        fetchReviewData();
    }, [typeSel, refetch, offSet]);

    const paginationClick = (number, offSetNumber) => {
        if (Math.ceil(totalData / limit) > 1) {
            setPageNumber(+number);
            setOffSet(+offSetNumber);
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        }
    };

    return (
        <div>
            {loading && (
                <div className='loadingBackground'>
                    <ReactLoading type='spin' color='#006aff' className='loadingSpin' />
                </div>
            )}
            <div>
                <div>
                    <TitleBar title='My Reviews' />
                    <div className='customContainer'>
                        {reviewData?.length === 0 && !loading ? (
                            <EmptyPage />
                        ) : (
                            reviewData?.map((item, index) => (
                                <TripStrap key={index} page={'bookings'} data={item} setRefetch={setRefetch} />
                            ))
                        )}
                    </div>
                    <div className='myBookingPagination'>
                        <Pagination
                            paginationClick={paginationClick}
                            numberOfRows={totalData}
                            offSet={offSet}
                            pageNumber={pageNumber}
                            limit={limit}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}
